import { createMachine } from "xstate";
import { IServiceStatus } from "@nju/data-access-portal-product";
import { changeSubscriptionStatus } from "@nju/data-access-portal-service";
import { BasicError } from "@nju/result";

interface IContext {
  productId?: string;
  currentStatus?: IServiceStatus["mobileServiceStatus"];
}

type IEvent =
  | { type: "CANCEL_SERVICE_RESIGNATION" }
  | { type: "CANCEL_SERVICE_RESIGNATION_SUCCESS" }
  | { type: "CANCEL_SERVICE_RESIGNATION_ERROR" }
  | { type: "ERROR" };

export const mobileServiceCTABannerMachine = createMachine<IContext, IEvent>(
  {
    schema: {
      context: {} as IContext,
      events: {} as IEvent,
    },
    initial: "ready",
    states: {
      ready: {
        on: {
          CANCEL_SERVICE_RESIGNATION: {
            target: "cancelServiceResignation",
          },
        },
      },
      cancelServiceResignation: {
        invoke: {
          src: "changeSubscriptionStatus",
        },
        on: {
          CANCEL_SERVICE_RESIGNATION_SUCCESS: {
            actions: "onCancelServiceResignationSuccess",
            type: "final",
          },
          CANCEL_SERVICE_RESIGNATION_ERROR: {
            actions: "onCancelServiceResignationError",
            target: "error",
          },
        },
      },
      error: {
        type: "final",
      },
    },
  },
  {
    services: {
      changeSubscriptionStatus: ({ productId, currentStatus }) => {
        return async (callback) => {
          if (!productId || !currentStatus) {
            throw new BasicError({ message: "Missing required fields" });
          }

          const result = await changeSubscriptionStatus(productId, {
            oldStatus: currentStatus,
            newStatus: "Active",
          });

          if (!result.isOk) {
            callback({ type: "CANCEL_SERVICE_RESIGNATION_ERROR" });
          }

          return callback({ type: "CANCEL_SERVICE_RESIGNATION_SUCCESS" });
        };
      },
    },
  },
);
